<template>
  <div class="employee-issues-analytics">
    <div class="employee-issues-analytics__tabs">
      <div v-for="tab in TABS" :key="tab.key" class="employee-issues-analytics__tab" @click="changeTab(tab.key)"
           :class="{'employee-issues-analytics__tab_active': tab.key === selectedTab}">
        <div :style="{background: tab.color}" class="employee-issues-analytics__tab-header"/>
        {{tab.name}}
      </div>
    </div>
    <app-panel flex class="employee-issues-analytics__panel">

      <div class="employee-issues-analytics__filters">
        <div class="employee-issues-analytics__quick-filters-date">
          <div class="employee-issues-analytics__quick-filter-date"
               :class="{'employee-issues-analytics__quick-filter-date_active' : isTodayFilter}"
               @click="setQuickDateFilter('today')"
          >
            Сегодня
          </div>
          <div class="employee-issues-analytics__quick-filter-date"
               :class="{'employee-issues-analytics__quick-filter-date_active' : isYesterdayFilter}"
               @click="setQuickDateFilter('yesterday')">
            Вчера
          </div>
          <div class="employee-issues-analytics__quick-filter-date"
               :class="{'employee-issues-analytics__quick-filter-date_active' : isWeekFilter}"
               @click="setQuickDateFilter('week')"
          >
            Неделя
          </div>
          <div class="employee-issues-analytics__quick-filter-date"
               :class="{'employee-issues-analytics__quick-filter-date_active' : isMonthFilter}"
               @click="setQuickDateFilter('month')"
          >
            Месяц
          </div>
          <div class="employee-issues-analytics__quick-filter-date"
               :class="{'employee-issues-analytics__quick-filter-date_active' : isQuarterFilter}"
               @click="setQuickDateFilter('quarter')"
          >
            Квартал
          </div>
          <div class="employee-issues-analytics__quick-filter-date"
               :class="{'employee-issues-analytics__quick-filter-date_active' : isYearFilter}"
               @click="setQuickDateFilter('year')"
          >
            Год
          </div>
        </div>

        <div class="employee-issues-analytics__filters-date">
          <app-datepicker class="employee-issues-analytics__filter-date" v-model="datePeriod.from"/>
          <app-datepicker class="employee-issues-analytics__filter-date" v-model="datePeriod.to"/>
        </div>

        <div v-if="selectedTab === 'houses'" class="employee-issues-analytics__select-house">
          <SelectBuildings v-model="buildings"/>
        </div>

        <div v-if="selectedTab === 'performers'" class="employee-issues-analytics__select-performer">
          <app-v-select :options="performers"
                        :clearable="false"
                        :searchable="true" v-model="performer" style="width: 100%" append-to-body>
            <template slot="selected-option" slot-scope="option">
              <div style="display: flex; align-items: center;">
                <app-avatar :img="$options.filters.imgPath(option.avatar)" :name="option.name"
                            class="employee-issues-analytics__select-performer-avatar" size="20px"/>
                <div class="employee-issues-analytics__select-performer-name">{{option.name}}</div>
              </div>
            </template>
            <template slot="option" slot-scope="option">
              <div style="display: flex; align-items: center;">
                <app-avatar :img="$options.filters.imgPath(option.avatar)" :name="option.name"
                            class="employee-issues-analytics__select-performer-avatar" size="20px"/>
                <div class="employee-issues-analytics__select-performer-name">{{option.name}}</div>
              </div>
            </template>
            <template slot="no-options">
              Пользователи не найдены
            </template>
          </app-v-select>
        </div>
      </div>

      <template>
        <BuildingsAnalytics v-if="selectedTab === 'houses'" ref="buildingsAnalyticsPanel" :period="datePeriod"
                            :buildings="buildings"/>
        <PerformersAnalytics v-else-if="selectedTab === 'performers'" ref="performersAnalyticsPanel"
                             :period="datePeriod" :performer="performer" :isPerformersLoaded="isPerformersLoaded"/>
      </template>

    </app-panel>
  </div>
</template>

<script>
  import SelectBuildings from "@/components/calculated-program/reports/components/SelectBuildings";
  import BuildingsAnalytics from "@/components/employee/issues/BuildingsAnalytics";
  import PerformersAnalytics from "@/components/employee/issues/PerformersAnalytics";

  const TABS = {
    houses: {
      id: null,
      name: 'Дома',
      key: 'houses',
      color: 'rgb(0, 140, 233)',
    },
    performers: {
      id: null,
      name: 'Исполнители',
      key: 'performers',
      color: 'rgba(var(--app-warning))',
    }
  };

  export default {
    name: "IssuesAnalytics",
    components: {
      SelectBuildings,
      BuildingsAnalytics,
      PerformersAnalytics
    },
    data() {
      return {
        TABS: TABS,
        datePeriod: {
          from: null,
          to: null,
        },
        buildings: [],
        performers: [],
        performer: null,
        isMounted: false,
        isPerformersLoaded: false
      }
    },
    computed: {
      selectedTab() {
        return this.$route.params.type;
      },
      isTodayFilter() {
        let today = this.$moment(new Date()).startOf('day').unix();
        let from = this.$moment(this.datePeriod.from).startOf('day').unix();
        let to = this.$moment(this.datePeriod.to).startOf('day').unix();
        return today === to && from === to;
      },
      isYesterdayFilter() {
        let today = this.$moment(new Date()).startOf('day').unix();
        let from = this.$moment(this.datePeriod.from).startOf('day').unix();
        let to = this.$moment(this.datePeriod.to).startOf('day').unix();
        let dayFromToday = this.$moment(new Date).startOf('day').subtract(1, 'day').unix();

        return today === to && dayFromToday === from;
      },
      isWeekFilter() {
        let today = this.$moment(new Date()).startOf('day').unix();
        let from = this.$moment(this.datePeriod.from).startOf('day').unix();
        let to = this.$moment(this.datePeriod.to).startOf('day').unix();
        let dayFromToday = this.$moment(new Date).startOf('day').subtract(1, 'week').unix();

        return today === to && dayFromToday === from;
      },
      isMonthFilter() {
        let today = this.$moment(new Date()).startOf('day').unix();
        let from = this.$moment(this.datePeriod.from).startOf('day').unix();
        let to = this.$moment(this.datePeriod.to).startOf('day').unix();
        let dayFromToday = this.$moment(new Date).startOf('day').subtract(1, 'month').unix();

        return today === to && dayFromToday === from;
      },
      isQuarterFilter() {
        let today = this.$moment(new Date()).startOf('day').unix();
        let from = this.$moment(this.datePeriod.from).startOf('day').unix();
        let to = this.$moment(this.datePeriod.to).startOf('day').unix();
        let dayFromToday = this.$moment(new Date).startOf('day').subtract(3, 'month').unix();

        return today === to && dayFromToday === from;
      },
      isYearFilter() {
        let today = this.$moment(new Date()).startOf('day').unix();
        let from = this.$moment(this.datePeriod.from).startOf('day').unix();
        let to = this.$moment(this.datePeriod.to).startOf('day').unix();
        let dayFromToday = this.$moment(new Date).startOf('day').subtract(1, 'year').unix();

        return today === to && dayFromToday === from;
      },
      selectedHouseId() {
        return this.$store.getters['appUser/selectedHouse'].id;
      },
    },
    methods: {
      changeRouteParams(changeParamFunc) {
        let params = Object.assign(this.$route.params, changeParamFunc(this.$route.params));
        let query = Object.assign({}, this.$route.query);
        this.$router.push({params: params, query: query});
      },
      changeTab(key) {
        this.changeRouteParams((params) => {
          params.type = key;
          return params;
        });
      },
      setQuickDateFilter(type = 'week') {
        let today = this.$moment(new Date()).startOf('day').toDate();
        let dayFromToday = this.$moment(new Date()).startOf('day');

        switch (type) {
          case 'yesterday':
            dayFromToday = dayFromToday.subtract(1, 'day').toDate();
            break;
          case 'week':
            dayFromToday = dayFromToday.subtract(1, 'week').toDate();
            break;
          case 'month':
            dayFromToday = dayFromToday.subtract(1, 'month').toDate();
            break;
          case 'quarter':
            dayFromToday = dayFromToday.subtract(3, 'month').toDate();
            break;
          case 'year':
            dayFromToday = dayFromToday.subtract(1, 'year').toDate();
            break;
          case 'today':
          default:
            dayFromToday = dayFromToday.toDate();
            break;
        }
        this.$set(this, 'datePeriod', {
          from: dayFromToday,
          to: today,
        });
      },
      getPerformers() {
        return new Promise(async resolve => {
          try {
            let {data} = await this.$http.get('tasks-performers');
            this.performers = data;
            let currentPerformer = data.find(p => p.id === Number(localStorage['employee.issues-report.user.performer']));
            this.performer = currentPerformer ? currentPerformer.id : this.performers[0].id;
            this.$nextTick(() => {
              this.isPerformersLoaded = true;
            });

            resolve(data);
          } catch (e) {
            this.performers = [];
            resolve([]);
          }
        });
      },
      updateTabData() {
        if (this.selectedTab === 'houses') {
          this.$refs.buildingsAnalyticsPanel.updateData();
        } else if (this.selectedTab === 'performers') {
          this.$refs.performersAnalyticsPanel.updateData();
        }
      },
    },
    created() {
      this.setQuickDateFilter('week');
      this.getPerformers();
      this.buildings = localStorage['employee.issues-report.buildings.houses'] ? JSON.parse(localStorage['employee.issues-report.buildings.houses']) : [this.selectedHouseId]

    },
    mounted() {
      this.$nextTick(() => {
        this.isMounted = true;
      });
    },
    beforeRouteEnter(to, from, next) {
      let type = to.params.type;
      if (Object.values(TABS).map(tab => tab.key).includes(type)) {
        next();
      } else {
        next({name: 'uc_issues_analytics', params: {type: 'houses'}});
      }
    },
    watch: {
      datePeriod: {
        deep: true,
        handler() {
          if (!this.isMounted) return false;
          this.$nextTick(() => {
            this.updateTabData();
          });

        }
      },
      buildings() {
        if (!this.isMounted) return false;
        localStorage['employee.issues-report.buildings.houses'] = JSON.stringify(this.buildings);
        this.$nextTick(() => {
          this.updateTabData();
        });
      },
      performer() {
        if (!this.isMounted || !this.isPerformersLoaded) return false;
        localStorage['employee.task-report.user.performer'] = typeof this.performer === typeof 0 ? this.performer : (this.performer.id || 0);
        this.$nextTick(() => {
          this.updateTabData();
        });
      }
    }
  }
</script>

<style lang="scss">

  .employee-issues-analytics {
    flex: 1;
    display: flex;
    flex-direction: column;

    &__tabs {
      display: flex;
      flex: 0;
    }


    &__tab {
      background: rgba(248, 248, 248, 1);
      padding: 12px 15px 10px;
      border-bottom: 1px solid rgba(0, 0, 0, .1);
      border-right: 1px solid rgba(0, 0, 0, .1);
      position: relative;
      z-index: 10;
      user-select: none;
      line-height: 1.1;
      cursor: pointer;
      transition: background .3s ease, font-weight .3s ease;
      min-width: 90px;
      text-align: center;
      font-weight: 500;

      &-header {
        width: 100%;
        height: 2px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: .3;
        transition: all .3s ease;
      }

      &:first-child {
        border-left: 1px solid rgba(0, 0, 0, .1);
      }

      &_active {
        border-bottom-color: transparent;
        background: #fff;

        .employee-issues-analytics__tab-header {
          opacity: 1;
        }
      }
    }

    &__panel {
      flex: 1;
      border: 1px solid rgba(0, 0, 0, .1);
      border-top: none;

      .app-panel__body {
        display: flex;
        flex-direction: column;
      }
    }

    &__quick-filters-date {
      display: flex;
    }

    &__filters {
      display: flex;
      align-items: center;
    }

    &__quick-filter-date {
      border: 1px solid #ced4da;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 34px;
      min-width: 80px;
      border-left: none;
      user-select: none;
      cursor: pointer;

      &:first-child {
        border-radius: 2px 0 0 2px;
        border-left: 1px solid #ced4da;
      }

      &:last-child {
        border-radius: 0 2px 2px 0;
      }

      &:hover,
      &_active {
        background: rgba(var(--app-primary), 1);
        border: 1px solid rgba(var(--app-primary), 1);
        color: #fff;
      }
    }

    &__filters-date {
      display: flex;
      align-items: center;
      margin-left: 30px;
    }

    &__filter-date {
      position: relative;

      .vdp-datepicker {
        width: 120px;
      }

      & + & {
        padding-left: 30px;

        &:before {
          content: "";
          position: absolute;
          left: 7.5px;
          width: 15px;
          top: 50%;
          height: 2px;
          background: #ced4da;
          transform: translateY(-50%);
        }

      }
    }

    &__select-house {
      margin-left: 30px;
      width: 100%;
      max-width: 320px;

      .select-buildings {

        &__label {
          display: none;
        }

        &__text-wrapper {
          padding: 2px 7px;
          border: 1px solid #ced4da;
          border-radius: 2px;
          height: 34px;
          display: flex;
          align-items: center;
          font-size: 0.85rem;
        }
      }
    }

    &__select-performer {
      margin-left: 30px;
      width: 100%;
      max-width: 320px;

      .app-v-select-flat__select .vs__dropdown-toggle {
        min-height: 34px !important;
      }

      &-avatar {
        flex-shrink: 0;
        margin-right: 5px;
      }
    }

  }


</style>